import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'

function NavigationBar() {
  const refElement = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [menuOpen, setMenuOpen] = useState(false);
  const [iconOpen, setIconOpen] = useState(false);
  const [showMobileDropdown, setShowMobileDropdown] = useState(false);

  useEffect(() => {
    if (refElement.current) {
      refElement.current.style.display = 'none';
    }

    const handleResize = () => {
      const mobile = window.innerWidth <= 991;
      setIsMobile(mobile);
      if (!mobile) {
        setMenuOpen(false);
        setIconOpen(false);
        setShowMobileDropdown(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // useEffect(()=>{
  //   const script2 = document.createElement('script');
  //   script2.src = 'static/js/validnavs.js';
  //   document.body.appendChild(script2)
  // },[])

  function showDropdown() {
    if (refElement.current && !isMobile) {
      refElement.current.style.display = 'block';
    }
  }

  function hideDropdown() {
    if (refElement.current && !isMobile) {
      refElement.current.style.display = 'none';
    }
  }

  const handleToggleClick = () => {
    if (!isMobile) return;
    const navbar = document.querySelector('.navbar');
    const overlay = document.querySelector('.overlay-screen');
    const navbarCollapse = document.querySelector('.navbar-collapse');
    const header = document.querySelector('header');

    const isOpen = menuOpen;

    setMenuOpen(!isOpen);
    setIconOpen(!isOpen);

    navbar?.classList.toggle('navbar-responsive', !isOpen);
    navbar?.classList.toggle('force-sticky', !isOpen);
    overlay?.classList.toggle('opened', !isOpen);
    header?.classList.toggle('adjust-height', !isOpen);
    navbarCollapse?.classList.toggle('show', !isOpen);
    navbarCollapse?.classList.toggle('collapse-mobile', !isOpen);
  };

  return (
    <div>
      <header>
        {/* Start Navigation */}
        <nav className="navbar mobile-sidenav navbar-default validnavs navbar-fixed white no-background">
          <div className="container d-flex justify-content-between align-items-center">
            {/* Start Header Navigation */}
            <div className="navbar-header">
              <button
                type="button"
                className="navbar-toggle"
                onClick={handleToggleClick}
              >
                <i className={`fa ${iconOpen ? 'fa-times' : 'fa-bars'}`} />
              </button>
              <Link className="navbar-brand" to="/">
                <img title='Microcode Software'
                  src="static/img/logo-light.png"
                  className="logo logo-display"
                  alt="Logo"
                />
                <img title='Microcode Software'
                  src="static/img/logo.png"
                  className="logo logo-scrolled"
                  alt="Logo"
                />
              </Link>
            </div>
            {/* End Header Navigation */}
            {/* Collect the nav links, forms, and other content for toggling */}
            <div className="collapse navbar-collapse" id="navbar-menu">
              <div className="collapse-header">
                <img title='Microcode Software' src="static/img/logo.png" alt="Logo" />
                <button
                  type="button"
                  className="navbar-toggle"
                  onClick={handleToggleClick}
                >
                  <i className="fa fa-times" />
                </button>
              </div>
              <ul
                className="nav navbar-nav navbar-center"
                data-in="fadeInDown"
                data-out="fadeOutUp"
              >
                <li className="dropdown megamenu-fw">
                  <Link to="/">Home</Link>
                </li>
                <li className="dropdown">
                  <Link to="/about">About Us</Link>
                </li>
                <li
                  className="dropdown"
                  onMouseEnter={() => !isMobile && showDropdown()}
                  onMouseLeave={() => !isMobile && hideDropdown()}
                >
                  <Link
                    to="#"
                    onClick={(e) => {
                      if (isMobile) {
                        e.preventDefault();
                        setShowMobileDropdown(!showMobileDropdown);
                      }
                    }}
                  >
                    Our Services
                  </Link>
                  <ul
                    ref={refElement}
                    className="dropdown-menu"
                    style={{
                      display: isMobile ? (showMobileDropdown ? 'block' : 'none') : undefined,
                    }}
                  >
                    <li><Link to="/application-development">Application Development</Link></li>
                    <li><Link to="/social-media-marketing">Social Media Marketing</Link></li>
                    <li><Link to="/performance-marketing">Performance Marketing</Link></li>
                    <li><Link to="/software-development">Software Development</Link></li>
                    <li><Link to="/website-development">Website Development</Link></li>
                    <li><Link to="/shopify-development">Shopify Development</Link></li>
                    <li><Link to="/seo-services">Search Engine Optimization (SEO)</Link></li>
                  </ul>
                </li>
                <li><Link to="/blog">Blog</Link></li>
                <li><Link to="/contact">contact Us</Link></li>
              </ul>
            </div>
            {/* /.navbar-collapse */}
            <div className="attr-right">
              <div className="attr-nav">
                <ul>
                  <li className="contact">
                    <div className="call">
                      <div className="icon">
                        <i className="fas fa-comments-alt-dollar" />
                      </div>
                      <div className="info">
                        <p>Have any Questions?</p>
                        <h5>
                          <a href="mailto:contact@microcode.email">contact@microcode.email
                          </a>
                        </h5>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="attr-right d-block d-sm-block d-lg-none">
              <div className="attr-nav">
                <ul>
                  <li className="contact d-block d-sm-block d-lg-none">
                    <div className="call">
                      <a href="mailto:contact@microcode.email
">
                        <div className="icon">
                          <i className="fas fa-comments-alt-dollar" />
                        </div>
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* Overlay screen for menu */}
          <div className="overlay-screen" onClick={handleToggleClick} />
          {/* End Overlay screen for menu */}
        </nav>
        {/* End Navigation */}
      </header>
    </div>
  )
}

export default NavigationBar